import { render } from "./MultiFactorAuth.vue?vue&type=template&id=4b32b55c&ts=true"
import script from "./MultiFactorAuth.vue?vue&type=script&lang=ts"
export * from "./MultiFactorAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__